import DownloadUtils from '../../DownloadUtils';
import { registerDownloadTaskEventListeners } from './registerDownloadTaskEventListeners';
export const resumeIncompletedDownloads = async (client) => {
    const lostTasks = await DownloadUtils.checkForExistingDownloads();
    for (const task of lostTasks) {
        const op = registerDownloadTaskEventListeners({ task, client });
    }
};
//# sourceMappingURL=resumeIncompletedDownloads.js.map